import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { ValidationException } from "@/common/exceptions/ValidationException";
export var api__contactUsSubmit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(formData) {
    var res, _res, _res$data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          dispatchButtonLoading(true);
          _context.p = 1;
          _context.n = 2;
          return fetcher().post("/site/contact-us", formData);
        case 2:
          res = _context.v;
          if (!(res.data && res.data.success && res.data.data != null && ((_res = res) === null || _res === void 0 ? void 0 : (_res$data = _res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) != "230")) {
            _context.n = 3;
            break;
          }
          res.data.data;
          _context.n = 4;
          break;
        case 3:
          throw new Error("Validation Error");
        case 4:
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          throw ValidationException.factoryFromAxios(res);
        case 6:
          _context.p = 6;
          dispatchButtonLoading(false);
          return _context.f(6);
        case 7:
          return _context.a(2);
      }
    }, _callee, null, [[1, 5, 6, 7]]);
  }));
  return function api__contactUsSubmit(_x) {
    return _ref.apply(this, arguments);
  };
}();